import LANG_CONST from '../../helpers/lang/const';

const resize = 1;
export const remCss = (v) => {
  return v * resize;
};

export const remFontCss = (v) => {
  return v * resize;
};

export const tabs = [
  { id: 'doctors', label: LANG_CONST.titles.doctors },
  { id: 'treatments', label: LANG_CONST.titles.treatments },
  { id: 'contact', label: LANG_CONST.titles.contact },
  { id: 'gallery', label: LANG_CONST.titles.gallery }
];
